import axios from 'axios'
import {
  getUserToken,
  getUserUid
} from './functions.js'
import { getServerApi } from './config/deployment'

let envUri = getServerApi()
let NOTES_URL = envUri + '/api/notes'
let PROPERTY_NOTES = 'property'


export const getPropertyNotes = async (propertyId, accountId) => {
  var token = await getUserToken();
  var params = {
    token,
    propertyId,
    accountId
  }
  var noteResp = await axios.get(`${NOTES_URL}/${PROPERTY_NOTES}`, {params})
  return noteResp.data.body
}


export const uploadNote = async (note, listingId, accountId) => {
  var token = await getUserToken()
  var uid = await getUserUid()
  var data = {
    id: note._id,
    title: note.title,
    body: note.body,
    createdAt: note.createdAt,
    updatedAt: note.updatedAt,
    userUid: uid,
    listingMaaklerId: listingId,
    archived: note.archived.toString(),
    token: token,
    accountId: accountId
  }

  var noteResp = await axios.put(NOTES_URL, data)
  if (!note._id && noteResp.data.body._id) note._id = noteResp.data.body._id
  return note
  
}



// WEBPACK FOOTER //
// ./src/notesRepository.js